export default __webpack_public_path__ + "static/media/app_logo.c293ce7c.svg";